<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <el-input
    v-model="displayText"
    v-bind="innerAttrs"
    placeholder="--"
    :type="inputType || 'text'"
    :disabled="true"
    :maxlength="inputMaxlength"
    :show-word-limit="innerShowWordLimit"
  />
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { _, computed, useCurrentAppInstance } from '@zto/zpage'
import type { GenericFunction } from '@zto/zpage'
import { useFormItem } from '../util'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
    tpl?: string
    formatter?: string | Record<string, any> | GenericFunction
    emptyText?: string
    inputType?: string
    maxlength?: number
    showWordLimit?: boolean
  }>(),
  {
    showWordLimit: undefined,
    emptyText: '--'
  }
)

const app = useCurrentAppInstance()

const inputConfig = app?.useComponentsConfig('formItem.input', {})
const textareaConfig = app?.useComponentsConfig('formItem.textarea', {})

const { innerAttrs } = useFormItem(props)

const inputMaxlength = computed(() => {
  if (props.maxlength) return props.maxlength

  if (props.inputType === 'textarea') return textareaConfig.maxlength || 300
  return inputConfig.maxlength || 100
})

const innerShowWordLimit = computed(() => {
  if (_.isBoolean(props.showWordLimit)) {
    return props.showWordLimit
  }

  // 默认textarea显示字数限制
  if (props.inputType === 'textarea') return true

  return false
})

const displayText = computed(() => {
  let text = props.model[props.prop]

  if (props.formatter) {
    text = app.formatText(text, props.formatter, { model: props.model })
  } else if (props.tpl) {
    text = app.filter(props.tpl, props.model)
  }

  if (props.emptyText && _.isEmpty(text)) {
    return props.emptyText
  }

  return text
})
</script>
